<template>
<div class="col-12 formDateLieu">
    <div class="form">
        <h4 class="titre">Vous êtes ?</h4>
        <div class="inputRadio">
            <input type="radio" value="Professionnel" id="inputPro" v-model="typeClient">
            <label for="inputPro"> Professionnel</label>
        </div>
        <div class="inputRadio">
            <input type="radio" value="Particulier" id="inputPart" v-model="typeClient">
            <label for="inputPart"> Particulier</label>
        </div>
        <transition name="fade">
            <div class="dateLieuForm" v-if="typeClient">
                <h5><i v-if="!noEmojis" class="em em-date" aria-role="presentation" aria-label="CALENDAR"/>Date de l'événement</h5>
                <!-- <Datepicker :monday-first="true" :language="fr" :format="'dd MMMM yyyy'" v-model="dateEvent" id="dateEvent"></Datepicker> -->
                <DatePickerBB v-model="dateEvent" />
                <h5><i v-if="!noEmojis" class="em em-round_pushpin" aria-role="presentation" aria-label="ROUND PUSHPIN"/>Lieu de l'événement</h5>
                <vue-google-autocomplete :country="['fr']" id="adresseClient" v-model="adresseEvent" v-on:placechanged="getAddressData" placeholder="Adresse précise de l'événement"></vue-google-autocomplete>
                <button @click="nextStep" class="button">Étape suivante</button>
                <div class="noEmojisContainer">
                    <input v-model="noEmojis" v-on:change="toggleNoEmojis" type="checkbox" id="checkbox">
                    <label style="font-weight: unset; font-size: 14px" for="checkbox">Je suis allergique aux emojis<i v-if="!noEmojis" class="em em-sneezing_face" aria-role="presentation" aria-label="SNEEZING FACE"></i></label>
                </div>
            </div>
        </transition>
    </div>
    <transition name="fade">
        <AlertDateSoon v-if="alertDateSoon" />
    </transition>
</div>
</template>

<script>
import AlertDateSoon from './AlertDateSoon'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Datepicker from 'vuejs-datepicker';
import {
    fr
} from 'vuejs-datepicker/dist/locale';
import JQuery from 'jquery'
let $ = JQuery

import DatePickerBB from './DatePicker';

export default {
    data() {
        return {
            typeClient: this.$store.getters.reservation_client.client.typeClient,
            dateEvent: this.$store.getters.reservation_client.evenement.date,
            adresseEvent: this.$store.getters.reservation_client.evenement.adresse,
            fr: fr,
            alertDateSoon: false,
            noEmojis: this.$store.getters.reservation_client.noEmojis,
        }
    },
    mounted: function() {
        $('html,body').animate({scrollTop: 0}, 'slow');
    },
    methods: {
        getAddressData: function (addressData, placeResultData, id) {
            this.adresseEvent = placeResultData['formatted_address'];
        },
        toggleNoEmojis() {
            this.$store.commit('toggleNoEmojis', true);
        },
        nextStep() {
            let dateEventFormat = new Date(this.dateEvent);
            let dateToday = new Date();
            // if (!this.adresseEvent) {
            //     $('#adresseClient').fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
            //     return;
            // }
            if (!this.dateEvent) {
                $('#dateEvent').fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
                return;
            }
            if (dateEventFormat < dateToday) {
                $("#textDateOut").remove();
                $("#dateEvent").after("<p id='textDateOut' style='color: #f677C4; text-align: center;'>Date expiré !</p>");
                $('#textDateOut').fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
                return;
            }

            var diffDays = parseInt((dateEventFormat - dateToday) / (1000 * 60 * 60 * 24), 10); 
            if (diffDays <= 0) {
                this.alertDateSoon = true;
                return;
            }
            
            //Enregistrer les infos dans le store
            this.$store.commit('RCsetTypeClient', this.typeClient);
            this.$store.commit('RCsetDateEvent', dateEventFormat);
            this.$store.commit('RCsetAddresseEvent', this.adresseEvent);
            this.$store.commit('RCetapeNext');
        }
    },
    components: {
        Datepicker,
        VueGoogleAutocomplete,
        AlertDateSoon,
        DatePickerBB
    }
}
</script>

<style scoped>
.formDateLieu {
    margin-bottom: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    padding: 2em;
    box-shadow: 0px 0px 5px 0px #aaa;
    background-color: #25327B;
}

h5 {
    display: flex;
    align-items: center;
    justify-content: center;
}

h5, label {
    color: #fff;
}

.form {
    width: 22em;
    margin: auto;
    text-align: center;
}

label {
    font-weight: bold;
    margin-left: 5px;
}

button {
    margin-top: 1em;
    width: 60%;
}

h5 {
    margin-top: 1em;
}

.noEmojisContainer {
    margin-top: 1em;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 465px) {
    .form {
        width: 100%;
    }

    .noEmojisContainer>label {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/Event.vue